import React, { useState, useEffect } from 'react'
import { useHistory } from 'react-router-dom'
import { useDispatch } from 'react-redux'
import { newPdfTemplate, newImageTemplate, newTextTemplate } from '../../store/actions/broadcastAction';
import UploadImage from "../../components/uploadImage";
import Header from '../../components/Header'
import CssBaseline from '@material-ui/core/CssBaseline';
import Menubar from '../../components/Menubar';
import TextField from '@material-ui/core/TextField';
import Button from '@material-ui/core/Button';
import { Container, Typography, Grid, Card, CardContent, Box, Select, MenuItem } from '@material-ui/core';
// import { MdAdd } from "react-icons/md";
import { makeStyles } from '@material-ui/core/styles';
import { useQuill } from 'react-quilljs';
import 'quill/dist/quill.snow.css';
import parse from "html-react-parser";
const Moment = require('moment');

const useStyles = makeStyles((theme) => ({
    appBar: {
      position: 'relative',
    },
    layoutMainCreateApp: {
      background: "white",
      padding: "2rem 2rem",
      borderRadius: "10px",
      [theme.breakpoints.up("sm")]: {
        width: "80%",
        marginLeft: 'auto',
        marginRight: 'auto',
      },
    },
    stepper: {
      padding: theme.spacing(3, 0, 5),
    },
    buttons: {
      display: 'flex',
      justifyContent: 'flex-end',
    },
    button: {
      marginTop: theme.spacing(3),
      marginBottom: theme.spacing(3),
      marginLeft: theme.spacing(1),
    },
    contentCreateApp : {
      paddingTop: "3%",
      paddingLeft: "15%",
      backgroundColor: "#e8e8e8",
      paddingRight: "5%",
      paddingBottom: "14%",

      [theme.breakpoints.down("sm")]: {
        paddingTop: "30%",
        paddingLeft: "0",
        paddingRight: "0"
      },
    },
    boxUploadTemplate: {
      border: '2px solid #b5b5b5',
      borderRadius: '5px',
      padding: '20px 10px',
      maxWidth: '150px',
    }
}));

const NewTemplate = () => {
  const classes = useStyles();
  const dispatch = useDispatch()
  const history = useHistory()
  const [typeInput, setTypeInput] = useState('text');
  const [header, setHeader] = useState('');
  const [message, setMessage] = useState('');
  const [messageConverted, setMessageConverted] = useState('');

  const [ input, setInput ] = useState({
    name: '',
    type: '',
    text: '',

    image: '',
    caption: '',

    pdf: ''
  })

  
  useEffect(() => {
    if (typeInput === 'text' || typeInput === 'pdf') {
      setInput({
        ...input,
        type: typeInput,
        text:
          `*${header}*\n${messageConverted}`
      })      
    } else if (typeInput === 'image') {
      setInput({
        ...input,
        type: typeInput,
        caption:
          `*${header}*\n${messageConverted}
          `
      })
    }
  }, [typeInput, header, messageConverted]);

  const selectTypeInput = (event) => {
    setTypeInput(event.target.value);
    setInput({ ...input, type: event.target.value })
  };

  const placeholder = 'Masukkan pesan yang ingin disampaikan';
  const { quill, quillRef } = useQuill({
    modules: {
      toolbar: "#toolbar"
    },
    formats: ["bold", 'italic'],
    placeholder
  });

  useEffect(() => {
    if (quill) {
      quill.on('text-change', function() {
        const textFormatted = quillRef.current.firstChild.innerHTML
        const textConverted = 
          textFormatted
          .replaceAll("<p>", "").replaceAll("</p>", "")
          .replaceAll("<strong>", "*").replaceAll("</strong>", "*")
          .replaceAll("<em>", "_").replaceAll("</em>", "_")
        setMessage(textFormatted)
        setMessageConverted(textConverted)        
      });
    }
  });  
    
  const counterRef = React.useRef();

  const uploadComponentData = {
    page: "newTemplate"
  }

  const handleHeader = (e) => {
    setHeader(e.target.value)
  }

  const handleChange = (e) => {
    let { name, value } = e.target
    setInput({ ...input, [name]: value })
  }

  const handleImageData = (imageFile) => {
    setInput({ ...input, image: imageFile, pdf: "" })
  }

  const handlePdfData = (pdfFile) => {
    setInput({ ...input, pdf: pdfFile, image: "" })
  }

  const handleBack = () => {
    history.push('/broadcast/template')
  }

  const handleSubmit = (e) => {
    e.preventDefault()
    const { name, type, text, caption, image, pdf } = input
    const formData = new FormData()
    if (pdf && type === 'pdf') {
      if (pdf) {
        formData.append('pdf', pdf)      
      }  
      formData.append('name', name)
      formData.append('type', type)
      formData.append('text', text)
      dispatch(newPdfTemplate(formData))
    } else if (input.type === 'image') {
      if (image) {
        formData.append('image', image)      
      }  
      formData.append('name', name)
      formData.append('type', type)
      formData.append('caption', caption)
      dispatch(newImageTemplate(formData))
    } else if (input.type === 'text') {
      const payload = {
        name, type, text
      }
      dispatch(newTextTemplate(payload))
    } else {
      console.log('invalid type');
    }
    history.push('/broadcast/template')
  }


  const renderMsg = parse(message)

  return (
    <React.Fragment>
      <Header page='newTemplate'/>
      <CssBaseline />
      <Menubar/>
      <Grid item xs={12} md={12} className={classes.contentCreateApp}>
      <Typography align="center" color="textPrimary" spacing={4} gutterBottom className="mb-20 reguler font-size-28">
        Buat Template Baru
      </Typography>
        <main className={classes.layoutMainCreateApp}>
          <Grid container xs={12} md={12}>
            <Grid item md={7} xs={12}>
              <p className="font-size-16 reguler text-darkgrey mb-5">Nama Template</p>
            <TextField
              variant="outlined"
              margin="none"
              size="small"
              placeholder="Masukkan Nama Template"
              required
              fullWidth
              name="name"
              onChange={handleChange}
            />
            <Grid container xs={12} md={12} className="my-2">
              <Grid item md={4} xs={12}>
                <p className="font-size-16 reguler text-darkgrey mb-5 mt-20">Header</p>
                <div class='selectTypeInput mb-5'>
                  <Select
                    value={typeInput}
                    onChange={selectTypeInput}
                    required
                    style={{width: '80%'}}
                    variant="outlined"
                  >
                    <MenuItem value={'text'}>Teks</MenuItem>
                    <MenuItem value={'image'}>Gambar</MenuItem>
                    <MenuItem value={'pdf'}>Pdf</MenuItem>
                  </Select>
                </div>
              </Grid>
              <Grid item md={8} xs={12}>
                <p className="font-size-16 reguler text-darkgrey mb-5 mt-20" style={{visibility: 'hidden'}}>Header</p>
                  <Box>
                    <TextField
                      variant="outlined"
                      margin="none"
                      size="small"
                      placeholder="Masukkan Header"
                      required
                      fullWidth
                      name="header"
                      onChange={handleHeader}
                      className="mb-15"
                    />
                    { typeInput === 'image' &&
                        <div className={classes.boxUploadTemplate}>
                          <UploadImage uploadComponentData={uploadComponentData} imageData={handleImageData}/>
                        </div>                        
                    }
                    { typeInput === 'pdf' &&
                        <div className={classes.boxUploadTemplate}>
                          <UploadImage uploadComponentData={uploadComponentData} pdfData={handlePdfData}/>
                        </div>
                    }
                    </Box>
                  </Grid>
                </Grid>
                <p className="font-size-16 reguler text-darkgrey mb-5 mt-25">Isi Pesan/Keterangan</p>
                <div style={{ width: '100%', height: 150 }}>
                  <div ref={quillRef}/>
                  <div id="toolbar" style={{display: 'flex', alignItems: 'center', background: '#e8e8e8'}}>
                    <span className='font-size-12'>Formatting Text :</span>
                    <button className="ql-bold" />
                    <button className="ql-italic" />
                  </div>
                  <div id="editor" />
                </div>
                <p className="font-size-16 reguler text-darkgrey mb-5" style={{marginTop: '4.5rem'}}>     </p>
                {/* <p className="font-size-16 reguler text-darkgrey mb-5" style={{marginTop: '4.5rem'}}>Tambahkan Variabel</p>
                <div>
                  Lorem
                </div> */}
                <div className="d-flex mt-25" style={{justifyContent: "flex-end"}}>
                <Button
                  variant="contained"
                  color="secondary"
                  className="btn-white text-transform-unset"
                  style={{padding: "5px 40px", marginRight: "20px"}}
                  onClick={handleBack}
                >
                  Batal
                </Button>
                <Button
                  type="submit"
                  variant="contained"
                  color="primary"
                  className="btn-black text-transform-unset"
                  style={{padding: "5px 40px"}}
                  onClick={handleSubmit}
                >
                  Simpan
                </Button>
                </div>
              </Grid>
              <Grid item md={5} xs={12}>
                <Box pl={5}>
                  <p className="font-size-16 reguler text-darkgrey mb-5">Preview</p>
                  <div style={{ position: 'relative'}}>
                    <img src='/wa-template.png' style={{width: '100%'}}/>
                    <div className='previewMessage'>
                    <p><b>{header}</b></p>
                    {renderMsg}
                    {/* <p>{renderMsg}</p> */}
                    <p style={{float:'right', fontSize: '10px', color: 'grey'}}>{Moment(new Date ()).format("HH:MM")}</p>
                    </div>
                  </div>
                </Box>
              </Grid>
            </Grid>
          </main>
        </Grid>
      </React.Fragment>     
    )
}

export default NewTemplate
